<template>
  <div>
    <h1
      class="choice-title"
      v-if="$store.getters?.getQuesInfo?.type === 1 && data?.isRequired"
      :class="{
        required: $store.getters?.getQuesInfo?.type === 1 && data?.isRequired,
      }"
    >
      <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
        `${quesIndex + 1}、`
      }}</span>
      {{ data?.title }}
      <span
        v-if="
          data.questionType !== 11 &&
          data.questionType !== 16 &&
          data.questionType !== 11 &&
          data.questionType !== 21 &&
          data.questionType !== 24 &&
          data.questionType !== 25
        "
        class="title-tip"
      >
      </span>
      <span v-if="$store.getters?.isShowType && $store.getters?.isShowType && data.questionType === 24" class="title-tip"> (简答题) </span>
    </h1>
    <h1 class="choice-title" v-else :class="{ required: showAnswerRequired }">
      <span v-if="$store.getters?.getQuesInfo?.showIndex">{{
        `${quesIndex + 1}、`
      }}</span>
      {{ data?.title }}
      <span v-if="$store.getters?.isShowType && data.questionType === 24" class="title-tip"> (简答题) </span>
      <span
        v-if="
          $store.getters?.isShowType &&
          data.questionType !== 11 &&
          data.questionType !== 16 &&
          data.questionType !== 11 &&
          data.questionType !== 21 &&
          data.questionType !== 24 &&
          data.questionType !== 25
        "
        class="title-tip"
      >
        (填空题)</span
      >
    </h1>
    <div class="choice">
      <div class="choice-item">
        <template v-if="data.questionType === 11 || data.questionType === 16">
          <Icon
            v-if="data.questionType === 11"
            name="user-o"
            size="22"
            color="#999"
          />
          <Icon
            v-if="data.questionType === 16"
            name="phone-o"
            size="20"
            color="#999"
          />
          <input
            v-model="value"
            :type="data.questionType === 16 ? 'number' : 'text'"
            :disabled="isReview"
            :placeholder="`请输入${data?.title}`"
            @focus="showLog = true"
            @blur="handleInputBlur"
          />
        </template>
        <Field
          v-else
          v-model="value"
          class="filed"
          autosize
          :disabled="isReview"
          rows="1"
          type="textarea"
          @focus="showLog = true"
          @blur="handleInputBlur"
          :placeholder="
            data?.questionType === 24 || data?.questionType === 4
              ? '请输入'
              : `请输入${data?.title}`
          "
        />
        <!-- 错误提示 -->
        <p class="error-message" v-if="showError">请输入正确的身份证号</p>
        <p class="error-message" v-if="showPhoneError">请输入正确的手机号</p>
        <div v-show="showLog && logList?.length > 0" class="log-wrap">
          <p
            class="log"
            v-for="log in logList"
            :key="log"
            @click.capture="handleLogClick(log)"
          >
            {{ log }}
          </p>
        </div>
      </div>
    </div>
    <template
      v-if="
      $store.getters.getQuesInfo.type === 3 &&
        data.questionType !== 11 &&
        data.questionType !== 16 &&
        data.questionType !== 21 &&
        data.questionType !== 25
      "
    >
      <div v-if="isReview">
        <template class="feedback animate__animated animate__fadeInDown">
          <div class="left green" v-if="data.value == data.answer">
            答案：正确
          </div>
          <div class="left red" v-else>答案：错误</div>
          <div v-if="$route.query.type !== '1'" class="right">
            正确答案：{{ data.answer }}
          </div>
        </template>
        <div
          v-if="
            data?.explanation &&
            $store.getters.getQuesSetting?.isExplanation === 2
          "
          class="explanation"
        >
          <img src="@/assets/img/explanation.png" alt="" />
          <p>解析：{{ data.explanation }}</p>
        </div>
      </div>
    </template>
    <!-- <Button
      v-if="data.questionType === 24 && show"
      type="primary"
      class="multi-submit"
      >提交答案</Button
    > -->
  </div>
</template>

<script>
import '../choice/css/choice.scss'
import { ref, watch, onMounted } from 'vue'
import { Icon, Field } from 'vant'
import { onBeforeRouteUpdate } from 'vue-router'
import { useStore } from 'vuex'
import { getAnswer } from '@/utils/tools'
// import { useStore } from 'vuex'

export default {
  props: {
    data: {
      type: Object,
      default: null,
    },
    quesIndex: {
      type: Number,
      default: 0,
    },
    currentChecked: {
      type: String,
      default: '',
    },
    // 临时处理答题必填显示
    showAnswerRequired: {
      type: Number,
      default: 0,
    },
    isReview: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Icon,
    Field,
  },
  emits: ['inputChange', 'changeVerify'],
  setup(props, ctx) {
    // const store = useStore()

    console.log('-xxxxxxxxxxxx', props)

    const value = ref('')
    const showError = ref(false)
    const showPhoneError = ref(false)

    watch(value, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        showLog.value = false

        if (props.data.questionType === 16) {
          if (!isPhoneRight(newValue)) {
            showPhoneError.value = true
            ctx.emit('changeVerify', true)
          } else {
            showPhoneError.value = false
            ctx.emit('changeVerify', false)
          }
        }

        if (props.data.questionType === 25) {
          if (newValue && !isIdNumRight(newValue)) {
            // 身份证不合法
            showError.value = true
            ctx.emit('changeVerify', true)
          } else {
            showError.value = false
            ctx.emit('changeVerify', false)
          }
        }

        ctx.emit('inputChange', {
          value: newValue,
          type: 'input',
          optionKey: props.data.optionVoList[0].optionKey,
          questionKey: props.data.questionKey,
          questionType: props.data.questionType,
        })
      }
    })

    onMounted(() => {
      if (props.data.value) {
        value.value = props.data.value
      }

      // 缓存的答案回显
      const localAnswer = getAnswer(props.data.questionKey)
      if (localAnswer) {
        value.value = localAnswer[0]?.answerContent
        // checked.value = localAnswer[0]?.optionKey
      }
    })

    onBeforeRouteUpdate(() => {

      if (props.data.value) {
        value.value = props.data.value
      } else {
        value.value = ''
      }

      if (props.currentChecked) {
        value.value = props.currentChecked
      }

      // 缓存的答案回显
      const localAnswer = getAnswer(props.data.questionKey)
      if (localAnswer) {
        value.value = localAnswer[0]?.answerContent
        // checked.value = localAnswer[0]?.optionKey
      }
    })

    const { showLog, handleLogClick, logList } = useLogEffect(
      value,
      props.data.questionKey
    )

    const handleInputBlur = () => {
      setTimeout(() => {
        if (showLog.value) {
          showLog.value = false
        }
      }, 200)
    }

    return {
      value,
      showLog,
      handleLogClick,
      showError,
      showPhoneError,
      logList,
      handleInputBlur,
    }
  },
}

const useLogEffect = (value, questionKey) => {
  const showLog = ref(false)
  const store = useStore()
  const logList = ref([])

  if (store.getters.getInputCacheListObj[questionKey]) {
    logList.value = store.getters.getInputCacheListObj[questionKey]
  }

  const handleLogClick = (log) => {
    value.value = log
    showLog.value = false
  }

  return {
    showLog,
    handleLogClick,
    logList,
  }
}

// 身份证号验证
const isIdNumRight = (idNum) => {
  const reg =
    /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/

  return reg.test(idNum)
}

// 手机号验证
const isPhoneRight = (idNum) => {
  const reg = /^(?:(?:\+|00)86)?1[3-9]\d{9}$/

  return reg.test(idNum)
}
</script>

<style lang="scss" scoped>
:root {
  --vant-field-placeholder-text-color: '#757575';
}
.choice {
  position: relative;
  input {
    margin-left: 10px;
    width: 100%;
    height: 100%;
    border: none;
  }

  .error-message {
    position: absolute;
    top: 2rem;
    color: #ee0a24;
    font-size: 0.4rem;
  }

  .log-wrap {
    position: absolute;
    left: -0.02rem;
    right: -0.02rem;
    top: 2rem;
    border: 0.02rem solid #e0e0e0;
    background-color: #fff;
    z-index: 2;

    .log {
      display: flex;
      align-items: center;
      padding-left: 0.5rem;
      height: 2rem;
      color: #333;
      border-bottom: 0.02rem solid #e0e0e0;
    }
  }
}
.filed {
  // max-height: 680px;
  box-sizing: border-box;
  padding: 0;
  margin: 10px 0;
  font-size: inherit;
}
</style>
<style lang="scss">
.van-field__body,
.van-field__control {
  box-sizing: border-box;
  height: 100%;
}
.van-cell::after {
  content: none;
}
.van-cell {
  background-color: transparent;
}
</style>
